import { API_BASE_URL } from "../config/config";

/**
 * Generic fetch function with error handling
 */
const fetchData = async (endpoint) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error(`Error fetching from ${endpoint}:`, error);
    throw error;
  }
};

/**
 * Generic fetch function with query string support
 */
const fetchWithQueryString = async (endpoint, queryString = "") => {
  try {
    const url = queryString
      ? `${API_BASE_URL}${endpoint}?${queryString}`
      : `${API_BASE_URL}${endpoint}`;
      
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error(`Error fetching from ${endpoint}:`, error);
    throw error;
  }
};

/**
 * Fetch all categories
 */
export const fetchCategories = async () => {
  try {
    return await fetchData("user/master-data/category/all/");
  } catch (error) {
    console.error("Failed to fetch categories:", error);
    return [];
  }
};

/**
 * Fetch all subcategories
 */
export const fetchSubCategories = async () => {
  try {
    return await fetchData("user/master-data/subcategory/all/");
  } catch (error) {
    console.error("Failed to fetch subcategories:", error);
    return [];
  }
};

/**
 * Fetch products by category
 */
export const fetchProductsByCategory = async (slug, queryString = "") => {
  try {
    const fullQueryString = queryString
      ? `slug=${slug}&${queryString}`
      : `slug=${slug}`;
    
    return await fetchWithQueryString(
      "user/products/get-products-by-category/",
      fullQueryString
    );
  } catch (error) {
    console.error("Failed to fetch products by category:", error);
    return [];
  }
};

/**
 * Fetch products by subcategory
 */
export const fetchProductsBySubCategory = async (slug, queryString = "") => {
  try {
    const fullQueryString = queryString
      ? `slug=${slug}&${queryString}`
      : `slug=${slug}`;
    
    return await fetchWithQueryString(
      "user/products/get-products-by-subcategory/",
      fullQueryString
    );
  } catch (error) {
    console.error("Failed to fetch products by subcategory:", error);
    return [];
  }
};

/**
 * Fetch all collections
 */
export const fetchCollections = async () => {
  try {
    return await fetchData("user/master-data/collection/all/");
  } catch (error) {
    console.error("Failed to fetch collections:", error);
    return [];
  }
};

/**
 * Fetch products by collection
 */
export const fetchProductsByCollection = async (slug, queryString = "") => {
  try {
    const fullQueryString = queryString
      ? `slug=${slug}&${queryString}`
      : `slug=${slug}`;
    
    return await fetchWithQueryString(
      "user/products/get-products-by-collection/",
      fullQueryString
    );
  } catch (error) {
    console.error("Failed to fetch products by collection:", error);
    return [];
  }
};